import { requestAuthed, requestAuthedJson, resolveTokenFromAuthHeaders, toErrorMessage } from '../../lib/api/http'

type Translator = (key: string, params?: Record<string, string | number>) => string

type AuthHeadersResolver = (withJson?: boolean) => Record<string, string>

export const requestSecuritySessions = async ({
  authHeaders,
  t,
}: {
  authHeaders: AuthHeadersResolver
  t: Translator
}): Promise<unknown[]> => {
  const data = await requestAuthedJson({
    token: resolveTokenFromAuthHeaders(authHeaders),
    path: '/admin/sessions',
    fallbackError: t('security.sessions.loadError'),
  })
  return Array.isArray((data as { sessions?: unknown }).sessions)
    ? ((data as { sessions: unknown[] }).sessions)
    : []
}

export const requestTrustSecuritySession = async ({
  authHeaders,
  sessionId,
  t,
}: {
  authHeaders: AuthHeadersResolver
  sessionId: string
  t: Translator
}) =>
  requestAuthedJson({
    token: resolveTokenFromAuthHeaders(authHeaders),
    path: `/admin/sessions/${encodeURIComponent(sessionId)}/trust`,
    init: {
      method: 'POST',
      headers: authHeaders(),
    },
    fallbackError: t('security.sessions.trustError'),
  })

export const requestRevokeSecuritySession = async ({
  authHeaders,
  sessionId,
  t,
}: {
  authHeaders: AuthHeadersResolver
  sessionId: string
  t: Translator
}) => {
  const { response, payload } = await requestAuthed({
    token: resolveTokenFromAuthHeaders(authHeaders),
    path: `/admin/sessions/${encodeURIComponent(sessionId)}`,
    init: {
      method: 'DELETE',
      headers: authHeaders(false),
    },
  })
  if (!response.ok) {
    throw new Error(toErrorMessage(payload, t('security.sessions.revokeError')))
  }
  return { isCurrent: Boolean(payload?.isCurrent) }
}
